let view = null;

export default {
	namespace: 'template-our-approach',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: OurApproachView } = await import(
			/* webpackChunkName: "our-approach-view" */ '../../templates/OurApproachView'
		);
		view = new OurApproachView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
